import React from "react";
import SubscriptionPage from "./subscriptionPage";

const Subscription: React.FC = () => {
  return <SubscriptionPage />;
};

export default Subscription;
